/**
 * Client-side feature flags.
 *
 * Flags are read from Vite env vars at build time. A flag is ON only when the
 * env var is the literal string "true" — anything else (unset, "false", "0",
 * empty) keeps the feature off. Off-by-default is the safer posture: forgetting
 * to set a flag hides a feature instead of shipping it.
 *
 * To enable locally: add `VITE_FEATURE_<NAME>=true` to `apps/dashboard/.env.local`.
 * To enable in CI/prod: set the same env var in the build environment so Vite
 * inlines it into the bundle.
 *
 * Flags in this file gate UI (sidebar entries, routes). They do NOT gate API
 * routes — removing a flagged feature from the client doesn't remove it from
 * the server, and that's intentional: users who manually know a URL shouldn't
 * crash, they should just miss the entry point.
 */

const isOn = (value: string | undefined): boolean => value === "true";

export const features = {
  /** Project terminology page — curated domain glossary. */
  terminology: isOn(import.meta.env.VITE_FEATURE_TERMINOLOGY),
  /** Background discovery of regulatory/compliance sources during wizard. Off by default for V1. */
  sourcesDiscovery: isOn(import.meta.env.VITE_FEATURE_SOURCES_DISCOVERY),
  /** Regulatory knowledge base & source ingestion. Off by default for V1 experience testing. */
  knowledgeSources: isOn(import.meta.env.VITE_FEATURE_KNOWLEDGE_SOURCES),
  /** Cloud browser runner / live walkthrough execution. Deferred post-1.0; off by default. */
  liveWalkthrough: isOn(import.meta.env.VITE_FEATURE_LIVE_WALKTHROUGH),
} as const;
